import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AuthService } from '@fry/lib/auth';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { SecurityService } from '@fry/lib/security';

const manageDashboards = [
    {
        id: 'manage-dashboard',
        link: '/dashboards',
        title: $localize `Manage dashboard templates`,
        parent: 'dashboard'
    },
    {
        id: 'manage-summary',
        link: '/summaries',
        title: $localize `Manage summary templates`,
        parent: 'dashboard'
    }
];

const managePortals = [
    {
        id: 'manage-portal',
        link: '/portals',
        title: $localize `Manage bookings portal templates`,
        parent: 'dashboard'
    }
];


@Injectable()
export class DashboardMenu extends BaseMenuService {

    public constructor(auth: AuthService, security: SecurityService) {
        super(auth, security);
    }

    public cook(): Observable<MenuItem[]> {
        return this.mergeItems(
            of([{
                id: 'dashboard',
                title: $localize `Dashboard`
            }]),
            of([{
                id: 'user-dashboard',
                link: '/dashboard',
                title: $localize `Dashboard`,
                parent: 'dashboard'
            }]),
            this.menuWithPermission(manageDashboards, 'dashboards.manage'),
            this.menuWithPermission(managePortals, 'portals.manage'),
        )
    }
}
